export default "__VITE_ASSET__Dc4bMnLo__"